//  This component checks if given component is link
function checkIfComponentIsLink(component) {
    let exists = false;
    if (
        component.attributes.type === "link" ||
        component.attributes.tagName === "link" ||
        component.attributes["custom-name"] === "Link"
    ) {
        exists = true;
    }
    return exists;
}

/**
 * This functions checks if in a given component
 * in table with toolbars exists the given command
 */
const findIfToolbarExists = (component,command) => {

    let exists = false;
    if(component.attributes.toolbar !== undefined && component.attributes.toolbar !== null &&  Array.isArray(component.attributes.toolbar) === true){
      component.attributes.toolbar.forEach( (toolbarComp) => {
        if(toolbarComp.command === command){
          exists = true;
        }
      })
    }
    return exists;

}


//  This function adds move icon, if does not exists, to a given component
const addMoveIcon = (component) => {
  if(findIfToolbarExists(component, 'tlb-move') === false){
      component.attributes.toolbar.push({
        attributes: {
          class: "fa fa-arrows gjs-no-touch-actions",
          draggable: true 
        },
        command: "tlb-move"
      });
  }
}

//  This function adds clone icon, if does not exists, to a given component
const addCloneIcon = (component) => {
  if(findIfToolbarExists(component, 'tlb-clone') === false){
      component.attributes.toolbar.push({
        attributes: {
          class: "fa fa-clone",
        },
        command: "tlb-clone"
      });
  }
}

//  This function adds delete icon, if does not exists, to a given component 
const addDeleteIcon = (component) => {
  if(findIfToolbarExists(component, 'tlb-delete') === false){
      component.attributes.toolbar.push({
        attributes: {
          class: "fa fa-trash-o",
        },
        command: "tlb-delete"
      });
  }
}

//  This function adds edit general icon, if does not exist, to a given component 
const addEditGeneralIcon = (component) => {
  if(findIfToolbarExists(component, 'edit-data-element-general') === false){
      component.attributes.toolbar.push({
        attributes: {
          class: "fas fa-edit",
        },
        command: "edit-data-element-general"
      });
  }
}

const addCreateBlockIcon = (component) => {
  if(findIfToolbarExists(component, 'create-block') === false){
    component.attributes.toolbar.push({
      attributes: {
        class: "fas fa-plus-circle",
      },
      command: "create-block"
    });
}
}

/**
 * This function handles edit list components. If we have just convert 
 * a text component to link then the new component does not have a 
 * table with toolbars and we have to create it. Else if it is just a 
 * simple link component we handle it just a general component
 */
 const addEditLinkIcons = (component) => {
  if (
      component.attributes.toolbar.length === 4 || component.attributes.toolbar.length <= 1
    ) {

      component.set("removable", true);
      component.set("copyable", true);
      component.set("droppable", true);
      component.set("draggable", true);


      if(component.attributes.toolbar === ''){
        component.attributes.toolbar = [];
        
        component.attributes.toolbar.push(  {
          attributes: { class: "fa fa-arrow-up" },
          command: "select-parent"
        })
        addMoveIcon(component);
        addCloneIcon(component);
        addDeleteIcon(component);
        addEditGeneralIcon(component);   
        addCreateBlockIcon(component);
      }
      
      if(component.attributes.toolbar !== '' && component.attributes.toolbar[0].command !== "edit-data-element-general"){
        
        addMoveIcon(component);
        addCloneIcon(component);
        addDeleteIcon(component);
        addEditGeneralIcon(component);   
        addCreateBlockIcon(component);
      }              
      
    }
}

//  This function add general components, if they do not exist to a given component 
const addEditIconsGeneralComp = (component) => {
  if(component.attributes.toolbar !== undefined ){
    addMoveIcon(component);
    addCloneIcon(component);
    addDeleteIcon(component);
    addEditGeneralIcon(component);    
    addCreateBlockIcon(component);
  }
}

/**
 * This function is called when a component inside GrapesJs 
 * is selected. According to the type of the selected component
 * we give the proportional edit option
*/
function addEditIconsFunc(component) {
  
  if (checkIfComponentIsLink(component) === true) {
    addEditLinkIcons(component);
  //  If selected component is general then we add edit general icon next to the component
  } else{
      addEditIconsGeneralComp(component)
  }
}

/**
 * This is the main function of the component.It contains the editor listener, 
 * which waits for a component to be selected and then fires addEditIconsFunc
*/
const addEditIcons = (editor) => {
    
  editor.on("component:selected",  (component) => {
    addEditIconsFunc(component);
  })
}

export {
    addEditIcons,
    addEditIconsFunc
}